import { reactive } from 'vue';

const versions = reactive<Record<string, number>>({});

/**
 * Tells the console that a video's captions changed (created, duplicated, translated, published, unpublished,
 * deleted, edited, uploaded, or finished processing),
 * so views derived from them, such as the preview player's draft subtitles, re-compute.
 */
export function notifyCaptionsChanged(videoKey: string): void {
  versions[videoKey] = (versions[videoKey] ?? 0) + 1;
}

export function captionsChangedVersion(videoKey: string): number {
  return versions[videoKey] ?? 0;
}
